import { PaletteMode } from '@mui/material';
import { ThemeOptions } from '@mui/material/styles';

export const themeOptions = {
    palette: {
        mode: 'dark' as PaletteMode,
    },
} as ThemeOptions;
